<template>
  <div class="hello">
    <mt-button type="primary" @click="pay">支付</mt-button>
    <mt-button @click="authorize">授权</mt-button>
    <div class="links">
      <router-link to="/ticket/once">购票</router-link>
      <router-link to="/order/all">我的订单</router-link>
    </div>
    <div class="links">
      <router-link to="/coupon/gift">我的卡券</router-link>
      <router-link to="/myNewActivity">我的活动</router-link>
    </div>
    <div class="links">
      <router-link to="/activityList">活动列表</router-link>
      <router-link to="/information">资讯列表</router-link>
    </div>
    <div class="links">
      <router-link to="/coach/grade">教练列表</router-link>
      <router-link to="/rights">会员权益</router-link>
    </div>
    <div class="links">
      <router-link to="/mine">个人中心</router-link>
      <router-link to="/login">绑定手机号</router-link>
    </div>
    <div class="links">
      <router-link to="/getCoupon/1">领券</router-link>
      <router-link to="/userInfo">个人信息</router-link>
    </div>
    <div class="links">
      <router-link to="/error">Error</router-link>
      <router-link to="/course">购课</router-link>
    </div>
    <div class="links">
      <router-link to="/orderBill/1">电子小票</router-link>
      <router-link to="/myCourse/open">我的课程</router-link>
    </div>
    <div class="links">
      <router-link to="/subscribedCourse">已约课程</router-link>
      <router-link to="/startedCourse">已上课程</router-link>
    </div>
    <div class="links">
      <router-link to="/subscribeCourse">预约课程</router-link>
      <router-link to="/subscribeExperienceCourse">预约体验课</router-link>
    </div>
    <div class="links">
      <router-link to="/coursePay">课程支付</router-link>
      <router-link to="/chooseCourse">选择课程</router-link>
    </div>
    <div class="fixed-1"></div>
    <div class="fixed-2"></div>
  </div>
</template>

<script>
import axios from 'axios'
import Url from '@/common/js/url.js'
import Common from '@/common/js/common'
import wx from 'weixin-js-sdk'
import { Button } from 'mint-ui'
import 'mint-ui/lib/button/style.css'
export default {
  name: 'hello',
  mounted () {
    let locationUrl = location.href.split('?')[0]
    wx.ready(function () {
      wx.onMenuShareAppMessage({
        title: '测试',
        desc: '测试内容',
        link: locationUrl,
        imgUrl:
          'https://ss0.bdstatic.com/94oJfD_bAAcT8t7mm9GUKT-xh_/timg?image&quality=100&size=b4000_4000&sec=1499307114&di=bb3fae16a21329b3ed8caabfa44a6a53&src=http://p.nanrenwo.net/uploads/allimg/170601/8467-1F601134222.jpg',
        type: '',
        dataUrl: '',
        success: function () {},
        cancel: function () {}
      })
      wx.onMenuShareTimeline({
        title: '朋友圈标题',
        link: locationUrl,
        imgUrl:
          'https://ss0.bdstatic.com/94oJfD_bAAcT8t7mm9GUKT-xh_/timg?image&quality=100&size=b4000_4000&sec=1499307114&di=bb3fae16a21329b3ed8caabfa44a6a53&src=http://p.nanrenwo.net/uploads/allimg/170601/8467-1F601134222.jpg',
        success: function () {},
        cancel: function () {}
      })
    })
  },
  data () {
    return {}
  },
  methods: {
    pay () {
      var that = this
      axios
        .get(Url.api + 'payapi/wx/getprepayinfo.do', {
          params: {
            authtoken: 'F763FF54A8144C10AACB2B9FAD73C93F'
          }
        })
        .then(res => {
          that.$wechat.pay(res.data)
        })
    },
    authorize () {
      Common.login()
    }
  },
  components: {
    MtButton: Button
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
.fixed-1 {
  position: fixed;
  top: 0;
  left: 0;
  width: 50px;
  height: 50px;
  z-index: 3;
  background-color: yellow;
}
.fixed-2 {
  position: fixed;
  top: 0;
  left: 0;
  width: 50px;
  height: 50px;
  z-index: 2;
  background-color: red;
}
.links {
  display: flex;
  a {
    display: inline-block;
    text-align: center;
    text-decoration: none;
    color: #333;
    flex-grow: 1;
    line-height: 40px;
    border: 1px solid #ebebeb;
    box-sizing: border-box;
  }
}
</style>



// WEBPACK FOOTER //
// Hello.vue?fa922524